module.exports = __webpack_public_path__ + "static/ISO45001Cert-6b6ea35fb533b81fe2b5f7565a401c39.svg";